<ng-template #settingsTemplate>
    <app-tool-setting label="Selecteer start/eind">
        <app-range-slider
            [max]="100"
            [range]="start"
            label="Start"
            (rangeChange)="handleStartChange($event)"
        ></app-range-slider>
        <app-range-slider
            [min]="1"
            [max]="100"
            [range]="distance"
            label="Breedte"
            (rangeChange)="handleDistanceChange($event)"
        ></app-range-slider>
    </app-tool-setting>
    <app-tool-setting label="Kies een waarde">
        <app-numbers-input
            [options]="[
                [-1, 1, 2, 3, 4, 5, 6, 7, 8, 9],
                [10, 20, 30, 40, 50, 60, 70, 80, 90]
            ]"
            (clear)="handleClear()"
            (undo)="handleUndo()"
            (numberChoice)="addStep($event)"
        ></app-numbers-input>
    </app-tool-setting>
    <app-tool-setting label="Richting">
        <app-radio-input
            [value]="1"
            [model]="direction"
            (selected)="setDirection($event)"
            >Vooruit</app-radio-input
        >
        <app-radio-input
            [value]="-1"
            [model]="direction"
            (selected)="setDirection($event)"
            >Achteruit</app-radio-input
        >
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 -10 1034 105"
        style="width: 1034px; height: 105px"
        xml:space="preserve"
    >
        <g class="base">
            <line
                class="big-line"
                style="fill: none; stroke: #000000; stroke-width: 1.5"
                [attr.x1]="lineCoords.x1"
                [attr.x2]="lineCoords.x2"
                [attr.y1]="lineCoords.y1"
                [attr.y2]="lineCoords.y2"
            ></line>
            <line
                class="vertical-line"
                style="fill: none; stroke: #000000; stroke-width: 1.5"
                [attr.y1]="verticalLineCoords.y1"
                [attr.y2]="verticalLineCoords.y2"
                [attr.x1]="firstPointCoords.x"
                [attr.x2]="firstPointCoords.x"
            ></line>
            <text
                class="text-under-vertical-line"
                [attr.transform]="
                    'matrix(1 0 0 1 ' +
                    (firstPointCoords.x - textOffset(start)) +
                    ' ' +
                    lowerTextCoords.y +
                    ')'
                "
                style="font-family: 'MuseoSans-300'; font-size: 22px"
            >
                {{ start }}
            </text>
        </g>

        @for (step of steps; track step; let last = $last) {
        <g class="step">
            <path
                class="arc"
                style="
                    clip-path: url(#SVGID_2_);
                    fill: none;
                    stroke: #004f9f;
                    stroke-width: 1.7;
                "
                [attr.d]="
                    'M' +
                    step.coords.x +
                    ',' +
                    firstPointCoords.y +
                    ' ' +
                    'q' +
                    step.distance / 2 +
                    ',-90,' +
                    step.distance +
                    ',0'
                "
            />
            <polygon
                class="arc-tip"
                style="clip-path: url(#SVGID_4_); fill: #004f9f"
                [attr.transform]="
                    'rotate(' +
                    arcTipRotate(step.distance) +
                    ' ' +
                    (step.coords.x + step.distance) +
                    ' ' +
                    firstPointCoords.y +
                    ')'
                "
                [attr.points]="
                    step.coords.x +
                    step.distance +
                    ',' +
                    firstPointCoords.y +
                    ' ' +
                    (step.coords.x + step.distance - 8 * direction) +
                    ',' +
                    (firstPointCoords.y - 3) +
                    ' ' +
                    (step.coords.x + step.distance - 3 * direction) +
                    ',' +
                    (firstPointCoords.y - 8)
                "
            />
            <text
                class="text-above-arc"
                [attr.transform]="
                    'matrix(1 0 0 1 ' +
                    (step.coords.x +
                        step.distance / 2 -
                        textOffset(step.value)) +
                    ' 14)'
                "
                style="font-family: 'MuseoSans-300'; font-size: 22px"
            >
                {{ step.value * direction }}
            </text>
            <line
                class="vertical-line"
                style="fill: none; stroke: #000000; stroke-width: 1.5"
                [attr.x1]="step.coords.x + step.distance"
                [attr.x2]="step.coords.x + step.distance"
                [attr.y1]="verticalLineCoords.y1"
                [attr.y2]="verticalLineCoords.y2"
            ></line>
            @if (last) {
            <g>
                <text
                    class="text-under-vertical-line"
                    [attr.transform]="
                        'matrix(1 0 0 1 ' +
                        (step.coords.x +
                            step.distance -
                            textOffset(total * direction)) +
                        ' ' +
                        lowerTextCoords.y +
                        ')'
                    "
                    style="font-family: 'MuseoSans-300'; font-size: 22px"
                >
                    {{ total }}
                </text>
            </g>
            }
        </g>
        }
    </svg>
</ng-template>
